var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"form-style",staticStyle:{"max-width":"700px"}},[_c('wrap-node',{attrs:{"value":_vm.slot_fields}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }